<template>
  <div class="container">
    <div class="row g-3 mb-4">
      <div class="col-md-3">
        <label class="form-label">الفصل الدراسي</label>
        <select
          v-model="form.term"
          @change="getSubjectswithtearm(form.term)"
          class="form-control"
        >
          <option value="">اختر الفصل الدراسي</option>
          <option v-for="t in terms" :key="t.id" :value="t">
            {{ t.name }}
          </option>
        </select>
      </div>

      
      <div class="col-md-3">
        <label class="form-label">المجموعة</label>
        <select
       
          v-model="form.group"
          class="form-control"
        >
          <option value="">اختر المجموعة</option>
          <option v-for="g in groups" :key="g.id" :value="g.id">
            {{ g.group_name }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">عدد مواد الرسوب</label>
        <select
        
          v-model="form.failCount"
          class="form-control"
        >
          <option value="">اختر العدد</option>
          <option value="1"> 1 </option>
          <option value="2"> 2 </option>
          <option value="3"> 3 </option>
          <option value="4"> 4 </option>
          <option value="5"> 5 </option>
          <option value="6"> 6 </option>
          <option value="7"> 7 </option>
          <option value="8"> 8 </option>
          <option value="9"> 9 </option>

        </select>
      </div>
    </div>
    <div class="card-body mb-4">
     
      <button
        @click="getResultsF(form.term, form.failCount, form.group)"
        class="btn btn-primary mt-4 mx-2 mb-2"
      >
       عرض الطلاب الراسبون
      </button>

      <button @click="print" class="btn btn-info mt-4 mx-2 mb-2">
        طباعة اﻻستعلام
      </button>
    </div>
<div id="printMe" class="row" >
      <!-- العنوان -->
      <div class="col-sm-12">
        <h1 class="text-center fh-25">
          كشف مراجعة رصد درجات مادة {{ form.subject["name"] }}
        </h1>
      </div>

      <!-- بيانات المجموعة والمراجعة -->
      <div class="col-sm-12 d-flex justify-content-between align-items-center">
        <h3 class="text-center fh-23">
          المجموعة _ {{ form.group }} المظروف _ {{ chunkIndex + 1 }}
        </h3>

      </div>
 <div class="col-sm-12 ">
  <table class="table">
  <thead >
    <tr>

          <th  scope="col">الرقم السري</th>
          <th  scope="col">عربى</th>
          <th  scope="col">انجليزى</th>
          <th scope="col">درسات</th>
          <th scope="col">جبر</th>
          <th scope="col">هندسة</th>
          <th scope="col">علوم</th>
          <th scope="col">دين</th>
          <th scope="col">فنية</th>
          <th scope="col">حاسب</th>
    </tr>
        </thead>
  <tbody>
          <tr v-for="sub in collection">
            <td scope="row">{{sub.SecretKey}}</td>
            <td :class="sub.ar_1 < 20 ? 'abs' : ''">{{sub.ar_1}}</td>
            <td :class="sub.en_1 < 15 ? 'abs' : ''">{{sub.en_1}}</td>
            <td :class="sub.stu_1 < 10 ? 'abs' : ''" >{{sub.stu_1}}</td>
            <td :class="sub.math_g_1 < 7 ? 'abs' : ''" >{{sub.math_g_1}}</td>
            <td :class="sub.math_h_1 < 7 ? 'abs' : ''" >{{sub.math_h_1}}</td>
            <td :class="sub.sci_1 < 10 ? 'abs' : ''" >{{sub.sci_1}}</td>
            <td :class="sub.tr_d_1 < 20 ? 'abs' : ''" >{{sub.tr_d_1}}</td>
            <td :class="sub.tr_f_1 < 10 ? 'abs' : ''" >{{sub.tr_f_1}}</td>
            <td :class="sub.com_1 < 5 ? 'abs' : ''" >{{sub.com_1}}</td>
      
          </tr>
        </tbody>
</table>

 
 </div>
</div>
  </div>
</template>

<script>
import api from "../../api/axios";
import _ from "lodash";
// import {
//     toArabic
// } from 'arabic-digits';
export default {
  data() {
    return {
      groups: [],
      subjects: [],
      terms: [],
      collection: [],
      form: {
        degree: "",
        group: "",
        subject: "",
        failCount: "",
      },
    };
  },

  mounted() {
    api.get("/getterms").then((res) => {
      this.terms = res.data;
    });

    api.get("/getgroups").then((res) => {
      this.groups = res.data;
    });
  },
  methods: {
    getSubjectswithtearm(id) {
      api.get("/getSubject/" + id.id).then((res) => {
        this.subjects = res.data;
      });
    },

    getResultsF(term, failCount, group) {
      api
        .get("/checkDegreeStudentF", {
          params: {
            failCount: failCount,
            term: term,

            group: group,
          },
        })
        .then((res) => {
          this.collection = res.data;
        })
        .catch((e) => {});
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
    chunk(value, count) {
      return _.chunk(value, count);
    },
  },
};
</script>

<style lang="scss" scoped>
// body {
//   font-size: 25px !important;
// }

// table,
// th,
// td {
//   border: 1px solid black !important;
//   padding: 2px;
// }

// table { 
//   border-spacing: 15px !important;
// }

// .table {
//   width: 100%;
//   margin-bottom: 5px !important;
//   color: #000000 !important;
// }

.abs {
  color: rgb(0, 0, 0);
  background: rgb(253, 1, 1) !important;
}
// .w100 {
//   width: 100% !important;
// }
</style>
